import { useTranslations } from '@qonsoll/translation'
import { PageWrapper } from '@qonsoll/react-design'
import { Content } from 'components'
import { CONTENT_TYPES } from '__constants__'

const AboutUs = () => {
  const { t } = useTranslations()

  const headingProps = {
    title: t('About us'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  return (
    <PageWrapper headingProps={headingProps}>
      <Content contentType={CONTENT_TYPES.ABOUT_US} />
    </PageWrapper>
  )
}

export default AboutUs
